import type { ISuggestion } from '../../helpers/models';

export const transformResData = ({ data, value }: ISuggestion, index: number) => ({
    id: index,
    data,
    label: value,
    subLabel: `ИНН: ${data.inn}`,
});
